/* unplugin-vue-components disabled */import { render } from "./SimpleQuiz.vue?vue&type=template&id=a043eedc&scoped=true&ts=true"
import script from "./SimpleQuiz.vue?vue&type=script&lang=ts"
export * from "./SimpleQuiz.vue?vue&type=script&lang=ts"

import "./SimpleQuiz.vue?vue&type=style&index=0&id=a043eedc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a043eedc"]])

export default __exports__